export default __webpack_public_path__ + "static/media/b-7.71f772d5.jpg";